module.exports = __webpack_public_path__ + "img/toplogo.bak.d85d0662.png";